import { msg } from '@lit/localize';
import type { ChatToolCallTrace } from './types';

export function isToolCallTrace(value: unknown): value is ChatToolCallTrace {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const trace = value as Partial<ChatToolCallTrace>;
  return (
    typeof trace.id === 'string' &&
    typeof trace.name === 'string' &&
    typeof trace.displayName === 'string' &&
    (trace.source === 'builtin' || trace.source === 'mcp') &&
    (trace.status === 'running' ||
      trace.status === 'succeeded' ||
      trace.status === 'failed') &&
    typeof trace.startedAt === 'string'
  );
}

export function upsertToolCallTrace(
  existing: ChatToolCallTrace[] | undefined,
  trace: ChatToolCallTrace
): ChatToolCallTrace[] {
  const current = existing ?? [];
  return current.some((entry) => entry.id === trace.id)
    ? current.map((entry) => (entry.id === trace.id ? trace : entry))
    : [...current, trace];
}

export function getToolStatusLabel(
  status: ChatToolCallTrace['status']
): string {
  switch (status) {
    case 'succeeded':
      return msg('Succeeded');
    case 'failed':
      return msg('Failed');
    case 'running':
      return msg('Running');
  }
}

export function getToolSourceLabel(toolCall: ChatToolCallTrace): string {
  return toolCall.source === 'mcp' ? 'MCP' : msg('Built-in');
}

export function formatToolDuration(durationMs?: number): string | null {
  if (typeof durationMs !== 'number' || !Number.isFinite(durationMs)) {
    return null;
  }
  if (durationMs > 0 && durationMs < 1) {
    return '<1ms';
  }
  return durationMs >= 1000
    ? `${(durationMs / 1000).toFixed(1)}s`
    : `${Math.round(durationMs)}ms`;
}

export function formatToolArguments(
  args: ChatToolCallTrace['arguments']
): string | null {
  if (!args || Object.keys(args).length === 0) {
    return null;
  }
  return JSON.stringify(args, null, 2);
}
